/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalid_DivisionInputs */

const th_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบรุ่นนี้ แสดงทุกรุ่น`)
};

const en_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That division is unavailable. Showing all divisions.`)
};

const ja_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その部門はありません。すべての部門を表示しています。`)
};

const zh_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该分区不可用。正在显示全部分区。`)
};

const es_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa categoría no está disponible. Se muestran todas las categorías.`)
};

const pt_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa categoria não está disponível. Mostrando todas as categorias.`)
};

const id_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisi itu tidak tersedia. Semua divisi ditampilkan.`)
};

const fr_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette catégorie n’est pas disponible. Toutes les catégories sont affichées.`)
};

const tl_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi available ang dibisyong iyon. Ipinapakita ang lahat ng dibisyon.`)
};

const vi_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng đó không khả dụng. Đang hiển thị mọi bảng.`)
};

const ko_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그 디비전은 이용할 수 없습니다. 전체 디비전을 표시합니다.`)
};

const de_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Klasse ist nicht verfügbar. Es werden alle Klassen angezeigt.`)
};

const ru_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот дивизион недоступен. Показаны все дивизионы.`)
};

const tr_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O grup kullanılamıyor. Tüm gruplar gösteriliyor.`)
};

const it_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quella categoria non è disponibile. Vengono mostrate tutte.`)
};

const pl_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta grupa jest niedostępna. Pokazujemy wszystkie grupy.`)
};

const uk_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей дивізіон недоступний. Показано всі дивізіони.`)
};

const hi_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह वर्ग उपलब्ध नहीं है। सभी वर्ग दिखाए जा रहे हैं।`)
};

const ar_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تلك الفئة غير متاحة. تُعرض كل الفئات.`)
};

const ms_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisyen itu tidak tersedia. Semua divisyen dipaparkan.`)
};

const bn_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই বিভাগ নেই। সব বিভাগ দেখানো হচ্ছে।`)
};

const zh_tw2_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該分組無法使用。正在顯示所有分組。`)
};

const zh_hk2_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該組別無法使用。正在顯示所有組別。`)
};

const ur_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ درجہ دستیاب نہیں۔ تمام درجے دکھائے جا رہے ہیں۔`)
};

const fa_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آن گروه در دسترس نیست. همهٔ گروه‌ها نشان داده می‌شود.`)
};

const sw_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daraja hilo halipatikani. Madaraja yote yanaonyeshwa.`)
};

const nl_invalid_division = /** @type {(inputs: Invalid_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die klasse is niet beschikbaar. Alle klassen worden getoond.`)
};

/**
* | output |
* | --- |
* | "That division is unavailable. Showing all divisions." |
*
* @param {Invalid_DivisionInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const invalid_division = /** @type {((inputs?: Invalid_DivisionInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalid_DivisionInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_invalid_division(inputs)
	if (locale === "ja") return ja_invalid_division(inputs)
	if (locale === "zh") return zh_invalid_division(inputs)
	if (locale === "es") return es_invalid_division(inputs)
	if (locale === "pt") return pt_invalid_division(inputs)
	if (locale === "id") return id_invalid_division(inputs)
	if (locale === "fr") return fr_invalid_division(inputs)
	if (locale === "tl") return tl_invalid_division(inputs)
	if (locale === "vi") return vi_invalid_division(inputs)
	if (locale === "ko") return ko_invalid_division(inputs)
	if (locale === "de") return de_invalid_division(inputs)
	if (locale === "ru") return ru_invalid_division(inputs)
	if (locale === "tr") return tr_invalid_division(inputs)
	if (locale === "it") return it_invalid_division(inputs)
	if (locale === "pl") return pl_invalid_division(inputs)
	if (locale === "uk") return uk_invalid_division(inputs)
	if (locale === "hi") return hi_invalid_division(inputs)
	if (locale === "ar") return ar_invalid_division(inputs)
	if (locale === "ms") return ms_invalid_division(inputs)
	if (locale === "bn") return bn_invalid_division(inputs)
	if (locale === "zh-TW") return zh_tw2_invalid_division(inputs)
	if (locale === "zh-HK") return zh_hk2_invalid_division(inputs)
	if (locale === "ur") return ur_invalid_division(inputs)
	if (locale === "fa") return fa_invalid_division(inputs)
	if (locale === "sw") return sw_invalid_division(inputs)
	if (locale === "nl") return nl_invalid_division(inputs)
	return en_invalid_division(inputs)
});